import { Component, OnInit } from '@angular/core';
import {UserService} from '../../../../user.service';
import {LabsService} from '../../../../labs.service';

import { Router } from '@angular/router';
@Component({
  selector: 'app-awsop-labs-nav',
  templateUrl: './awsop-labs-nav.component.html',
  styleUrls: ['./awsop-labs-nav.component.css']
})
export class AwsopLabsNavComponent implements OnInit {


  constructor(private userService: UserService, private router: Router,  private lab_s: LabsService) {}

  name = '';

  lab_number = 1;

  ngOnInit() {
    this.name = this.userService.fullname;
    this.lab_s.lab_number = 1;
    this.lab_number = this.lab_s.lab_number;
  }

  logout() {
    this.userService.fullname = "";
    this.userService.user = null;
    this.router.navigate(['/']);
  }

  setLabNumber(num) {
    this.lab_s.sendLab(num);
    this.router.navigate([`/course/awsop/dashboard`]);
  }

}



// WEBPACK FOOTER //
// ./src/app/course/labs/awsop/awsop-labs-nav/awsop-labs-nav.component.ts